import {
    createSelector,
    createFeatureSelector,
    MetaReducer, Action, combineReducers
} from '@ngrx/store';

import * as fromRoot from '../../store/app.reducers';
import * as fromPersona from './personas/persona.reducers';

export const personasFeatureKey = 'personas';

export interface PersonaState {
    [fromPersona.personasFeatureKey]: fromPersona.State;
}

export interface State extends fromRoot.AppState {
    [personasFeatureKey]: PersonaState;
}

/** Provide reducer in AoT-compilation happy way */
export function reducers(state: PersonaState | undefined, action: Action) {
    return combineReducers({
        [fromPersona.personasFeatureKey]: fromPersona.reducer
    })(state, action);
}

export const metaReducers: MetaReducer<State>[] = [];

export const getPersonasState = createFeatureSelector< PersonaState>('personas');

export const getPersonasEntitiesState = createSelector(
    getPersonasState,
    state => state.personas
);

export const getAllPersonas = createSelector(
    getPersonasEntitiesState,
    fromPersona.getAllPersonas
);

export const getPersonaEntities = createSelector(
    getPersonasEntitiesState,
    fromPersona.getPersonasEntities
);

export const getSelectedPersona = createSelector(
    getPersonasEntitiesState,
    fromPersona.getSelectedPersona
);

export const getSkipSelection = createSelector(
    getPersonasEntitiesState,
    fromPersona.getSkipSelection
);

export const getEveryonePersonaId = createSelector(
    getPersonasEntitiesState,
    fromPersona.getEveryonePersonaId
);
